import React from 'react';
import styles from '../MobileDashboardPage/MobileDashboardPage.module.scss';
import { LiveDataGrid } from '../../components/LiveDataGrid';
import { ECN_TRADE_SYMBOL_SUMMARY, ECN_TRADE_MMID_SUMMARY } from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();
const ECN_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_TRADE_SYMBOL_SUMMARY);
const ECN_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_TRADE_MMID_SUMMARY);

class MobileDashboardEcnGrids extends React.PureComponent {
  render () {
    const pauseRealTimeData = false;
    return (
      <div className={styles.ecnTables} >

        <LiveDataGrid
          identifier={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.header}
          ws={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.ws}
          api={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

        <LiveDataGrid
          identifier={ECN_TRADE_MMID_SUMMARY_CONFIG.identifier}
          header={ECN_TRADE_MMID_SUMMARY_CONFIG.header}
          ws={ECN_TRADE_MMID_SUMMARY_CONFIG.ws}
          api={ECN_TRADE_MMID_SUMMARY_CONFIG.api}
          downloadApi={ECN_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ECN_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_TRADE_MMID_SUMMARY_CONFIG.totalField}
          columns={ECN_TRADE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

      </div>
    );
  }
}

export default MobileDashboardEcnGrids;
export const MemoizedMobileDashboardEcnGrids = React.memo(MobileDashboardEcnGrids);
